/** Google Ads “Purchase” conversion label (same `send_to` as `gtag_report_purchase_conversion` in `public/index.html`). */
const PURCHASE_SEND_TO = "AW-11509160772/wkVbCP3g8qocEMS2_-8q";

/**
 * Fire after payment is verified server-side. Uses Razorpay `payment_id` as unique `transaction_id`.
 * Safe no-op when gtag is missing (local dev / blockers).
 * @param {string} [transactionId]
 * @param {boolean} [newCustomer] — Google Ads new customer acquisition; omit if unknown
 */
export function trackGoogleAdsVoiceTokenPurchase(transactionId, newCustomer) {
  if (typeof window === "undefined") return;
  const gtag = window.gtag;
  if (typeof gtag !== "function") return;

  const tid =
    transactionId != null && String(transactionId).trim()
      ? String(transactionId).trim()
      : "";

  gtag("event", "conversion", {
    send_to: PURCHASE_SEND_TO,
    ...(tid ? { transaction_id: tid } : {}),
    ...(typeof newCustomer === "boolean" ? { new_customer: newCustomer } : {}),
  });
}
